import { tableFormatter } from "@/helpers/functions";
import debounce from "lodash.debounce";
export default {
  props: ["payload"],
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
      orgMenu: [
        {
          label: "Employee",
          value: "employee",
        },
        {
          label: "Department",
          value: "department",
        },
        {
          label: "Team",
          value: "team",
        },
        {
          label: "Branch",
          value: "branch",
        },
        {
          label: "Grade",
          value: "grade",
        },
      ],
      // employeeSelected: [],
      multipleSelectionList: [],
      multipleSelectionSelected: [],
      selectedDepartment: [],
      selectedBranch: [],
      selectedTeam: [],
      selectedGrade: [],
      employeeList: [],
      employeeListTotal: null,
      loading: false,
      perPageEmployeeList: 5,
      pageEmployeeList: 1,
      departments: [],
      branches: [],
      teams: [],
      grades: [],
      category_type: "employee",
      unassignEmployee: [],
      assignEmployee: [],
      searchQuery: "",
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.pageEmployeeList;
      },
      set(value) {
        return (this.pageWorkRate = value);
      },
    },
  },
  mounted() {
    this.getEmployees();
    this.getDepartments();
    this.getBranches();
    this.getTeams();
    this.getGrades();
  },
  destroyed() {
    this.$localStorage.clear("employees");
  },

  methods: {
    tableFormatter,
    handleSelectionChangeEmployeeList(val) {
      this.multipleSelectionList = val;
    },
    handleSelectionChangeEmployeeSelected(val) {
      this.multipleSelectionSelected = val;
    },
    transfer() {
      const { assignedEmployees, unAssignedEmployees } = this.payload;
      const uniqueEmployees = this.multipleSelectionList.filter(el => {
        return !assignedEmployees.find(x => x.id === el.id);
      });
      const employeesNotSigned = unAssignedEmployees.filter(el => {
        return !this.multipleSelectionList.find(x => x.id === el.id);
      });
      this.$emit("updatePayload", {
        ...this.payload,
        assignedEmployees: [...assignedEmployees, ...uniqueEmployees],
        newlyAssigned: [...uniqueEmployees],
        unAssignedEmployees: employeesNotSigned,
        type: "employee",
      });
      this.getEmployees();
    },
    remove() {
      const {
        initiallyAssignedEmployees,
        assignedEmployees,
        unAssignedEmployees,
        newlyAssigned,
      } = this.payload;
      const filteredAssignedEmployees = assignedEmployees.filter(el => {
        return !this.multipleSelectionSelected.find(x => x.id === el.id);
      });
      const employeesNotAssigned = this.multipleSelectionSelected.filter(el => {
        return initiallyAssignedEmployees.find(x => x.id === el.id);
      });

      const newlyAssignedEmployees = newlyAssigned.filter(el => {
        return !this.multipleSelectionSelected.find(x => x.id === el.id);
      });

      this.$emit("updatePayload", {
        ...this.payload,
        assignedEmployees: filteredAssignedEmployees,
        newlyAssigned: newlyAssignedEmployees,
        unAssignedEmployees: [...unAssignedEmployees, ...employeesNotAssigned],
        type: "employee",
      });
    },
    resetCategory() {
      if (this.category_type === "employee") {
        return (
          (this.selectedDepartment = []),
          (this.selectedBranch = []),
          (this.selectedTeam = []),
          (this.selectedGrade = [])
        );
      }
      if (this.category_type === "team") {
        return (
          (this.selectedDepartment = []),
          (this.selectedBranch = []),
          (this.selectedGrade = []),
          (this.searchQuery = "")
        );
      }
      if (this.category_type === "branch") {
        return (
          (this.selectedDepartment = []),
          (this.selectedTeam = []),
          (this.selectedGrade = []),
          (this.searchQuery = "")
        );
      }
      if (this.category_type === "grade") {
        return (
          (this.selectedDepartment = []),
          (this.selectedBranch = []),
          (this.selectedTeam = []),
          (this.searchQuery = "")
        );
      }
      if (this.category_type === "department") {
        return (
          (this.selectedBranch = []),
          (this.selectedTeam = []),
          (this.selectedGrade = []),
          (this.searchQuery = "")
        );
      }
    },
    getEmployees(data) {
      this.loading = true;
      const params = {
        page: this.currentPage,
        per_page: this.perPageEmployeeList,
        ...(data && Object.keys(data).length > 0 && data),
      };
      this.$http
        .get("organization/employees/search", {
          params,
        })
        .then(response => {
          this.$localStorage.set(
            "employees",
            response.data.results ? response.data.results : response.data
          );
          this.employeeList = this.$localStorage.get("employees");
          this.employeeListTotal = response.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeCategory() {
      const categoryTypes = {
        employee: this.searchEmployees,
        department: this.getEmployeesByDepartment,
        team: this.getEmployeesByTeam,
        grade: this.getEmployeesByGrade,
        branch: this.getEmployeesByBranch,
      };
      this.resetCategory();
      return categoryTypes[this.category_type]() || this.getEmployees();
    },
    searchEmployees() {
      const searchQuery = this.searchQuery;
      if (!searchQuery || searchQuery === "") {
        this.currentPage = 1;
        this.perPageEmployeeList = 5;
        return this.getEmployees();
      }
      return this.getEmployees({ query: searchQuery });
    },
    getEmployeesByDepartment() {
      const departmentIds = this.selectedDepartment;
      if (this.isNotLengthy(departmentIds)) {
        return false;
      }
      return this.getEmployees({ department_ids: departmentIds });
    },
    getEmployeesByTeam() {
      const teamIds = this.selectedTeam;
      if (this.isNotLengthy(teamIds)) {
        return false;
      }
      return this.getEmployees({ team_ids: teamIds });
    },
    getEmployeesByGrade() {
      const gradeIds = this.selectedGrade;
      if (this.isNotLengthy(gradeIds)) {
        return false;
      }
      return this.getEmployees({ grade_ids: gradeIds });
    },
    getEmployeesByBranch() {
      const branchIds = this.selectedBranch;
      if (this.isNotLengthy(branchIds)) {
        return false;
      }
      return this.getEmployees({ branch_ids: branchIds });
    },
    isNotLengthy(data) {
      return !data || data.length <= 0;
    },
    handleSizeChangeEmployeeList(perPageEmployeeList) {
      this.perPageEmployeeList = perPageEmployeeList;
      this.pageEmployeeList = 1;
      this.getEmployees();
    },
    handleCurrentChangeEmployeeList(pageEmployeeList) {
      this.pageEmployeeList = pageEmployeeList;
      this.getEmployees();
    },
    getDepartments() {
      this.loading = true;
      this.$http
        .get("/organization/departments")
        .then(response => {
          this.departments = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBranches() {
      this.loading = true;
      this.$http
        .get("/organization/branches")
        .then(response => {
          this.branches = response.data.results;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTeams() {
      this.loading = true;
      this.$http
        .get("/organization/teams")
        .then(response => {
          this.teams = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getGrades() {
      this.loading = true;
      this.$http
        .get("organization/employees/settings/grades")
        .then(response => {
          this.grades = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    search: debounce(function() {
      this.searchEmployees();
    }, 500),
  },
};
